import {
  filter,
  orderBy,
} from 'lodash-es';
import moment from 'moment';

import {applyTo, applier} from 'utils/lodashHelpers';

export const getAllLicenses = (user, {product, onlyActive = true} = {}) => {
  if (!user) return;
  return applyTo(user.licenses)(
    applier(filter)((lic) => {
      return (lic.product == product || !product) && (!onlyActive || lic.is_active);
    }),
    // This logic mirrors the logic in the Django License model.
    applier(orderBy)(
      ['is_active', 'is_trial', (lic) => {
        return moment(lic.date_ends);
      }],
      ['desc', 'asc', 'desc']
    )
  );
};

export const SUBJECT_PRODUCTS = ['essentials', 'ela', 'science', 'social_studies'];
export const PRODUCT_NAME_MAPPING = {
  social_studies: 'Social Studies',
  science: 'Science',
  ela: 'ELA',
  essentials: 'Essentials',
};
